import React from 'react';
import { ROUTES } from 'config';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { locationLine } from 'static/icons/resizable';
import { Icon } from 'view/atoms';
import * as S from './LocationButton.styles';

export const LocationButton = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(ROUTES.location);
  };

  return (
    <S.ButtonChangeLocation
      type='button'
      kind='primary'
      onClick={handleOnClick}
    >
      <Icon src={locationLine} />
      {t('noDiscountsInLocationPage.changeLocation')}
    </S.ButtonChangeLocation>
  );
};
